import { WheelValue } from "../../../../util/enums";
import getFieldsWithValue from "./getFieldsWithValue";
import { calculateAngleFromField } from "./index";

const calculateAngleFromPrize = (spinNumber: number) => {
    switch (spinNumber) {
        case WheelValue.ONE:
            return calculateAngleFromField(getFieldsWithValue(WheelValue.ONE));
        case WheelValue.TWO:
            return calculateAngleFromField(getFieldsWithValue(WheelValue.TWO));
        case WheelValue.THREE:
            return calculateAngleFromField(getFieldsWithValue(WheelValue.THREE));
        case WheelValue.FOUR:
            return calculateAngleFromField(getFieldsWithValue(WheelValue.FOUR));
        case WheelValue.FIVE:
            return calculateAngleFromField(getFieldsWithValue(WheelValue.FIVE));
        case WheelValue.SIX:
            return calculateAngleFromField(getFieldsWithValue(WheelValue.SIX));
        case WheelValue.SEVEN:
            return calculateAngleFromField(getFieldsWithValue(WheelValue.SEVEN));
        case WheelValue.EIGHT:
            return calculateAngleFromField(getFieldsWithValue(WheelValue.EIGHT));
        case WheelValue.NINE:
            return calculateAngleFromField(getFieldsWithValue(WheelValue.NINE));
        case WheelValue.TEN:
            return calculateAngleFromField(getFieldsWithValue(WheelValue.TEN));
        default:
            return 0;
    }
}

export default calculateAngleFromPrize 